import React, { useState } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Container, Icon } from '@scentregroup/ui'

import { Centre as CentreType } from '../../../types/centre'
import { CentreSelector as SharedCentreSelector } from '../centre-selector'
import style from './index.scss'
import navStyle from './navStyle.scss'

const centreSelectorConfig = {
  allCentresLabel: 'All centres',
  inputLabel: 'Centre name',
  locationLabel: 'Near me',
}

export const CentreSelector = withRouter(
  ({
    centres,
    centre: currentCentre,
  }: RouteComponentProps & { centres: CentreType[]; centre?: CentreType }) => {
    const [open, setOpen] = useState<boolean>(false)
    const toggleOpen: () => void = () => setOpen(!open)
    const chevron = open ? 'chevron-down' : 'chevron-right'

    return (
      <>
        <div className={style.FindACentre}>
          <Container type="large">
            <button
              className={style.link}
              onClick={toggleOpen}
              onKeyDown={toggleOpen}
            >
              <Icon
                type="location-drop-pin"
                size="small"
                className={style.icon}
              />
              <span>Find a centre</span>
              <Icon type={chevron} size="small" className={style.icon} />
            </button>
          </Container>
        </div>
        {open && (
          <SharedCentreSelector
            centres={centres}
            centre={currentCentre}
            navStyle={navStyle}
            config={centreSelectorConfig}
          />
        )}
      </>
    )
  }
)
